import React, { Component } from 'react';
import _ from 'lodash';
import config from '../../../config';
import ProjectionStore from '../../../stores/ProjectionStore';
import FinancialStoriesActionCreator from '../../../actions/FinancialStoriesActionCreator';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import ProjectionActionCreator from '../../../actions/ProjectionActionCreator';
import BrowserUtils from '../../../utils/BrowserUtils';
import AnalyticsActionCreator from '../../../actions/AnalyticsActionCreator';
import { ProjectionSettings } from './ProjectionSettings';
import { ProjectionMobileSettings } from './projections-mobileview/ProjectionMobileSettings';

// variables and array declarations
let categoryTags = [];
let userTags = [];
let earningIDArray = [];
let earningsId = [];

function getStateFromStores() {
  return {
    overDraftAmount: ProjectionStore.getData(),
    currency: ProjectionStore.getCurrency(),
    alertsAmountValue: parseFloat(
      ProjectionStore.getProjectionAlertsAmountValue()
    ),
    notificationFlag:
      ProjectionStore.getProjectionAlertsNotificationBoolean()[0],
    earningsAndCommitmentsData: ProjectionStore.getEarningsAndCommitments(),
    categoryTags: ProjectionStore.getCategoryTags(),
    userTags: ProjectionStore.getUserTags(),
    newFlag: false,
    tagFlag: '',
    optOutFlag: false,
    cancelFlag: false,
    tourFlag: false,
    cancelButtonFlag: ProjectionStore.getCancelButtonFlag(),
    tour: ProjectionStore.getTourFlag(),
    activityIndicator: ProjectionStore.getActivityIndicator(),
    dLeaveSetup: false,
    crunch: ProjectionStore.getCrunching(),
    putProjectionPreferenceErrorHandlingFlag:
      ProjectionStore.putProjectionPreferenceErrorHandling(),
    putProjectionMessage: ProjectionStore.putProjectionErrorMEssage(),
    changeToGrid: false,
    dropdownSelection: 1,
    shakeamount: false,
    shakeamountZero: false,
    shakeSet: new Set(),
    dropDownFlag: false,
    index: 0,
    selectedValue: 1,
  };
}

/**
 * @todo
 * This component is of poor quality.
 * Future improvement work should be undertaken to get it to an acceptable
 * standard.
 */
class SettingsMainPage extends Component {
  constructor(props) {
    super(props);

    this.onStoreChange = this.onStoreChange.bind(this);
    this.onclickCancelForOptOut = this.onclickCancelForOptOut.bind(this);
    this.onclickLeaveSetup = this.onclickLeaveSetup.bind(this);
    this._cancel_button = this._cancel_button.bind(this);
    this._opt_out_of_projections = this._opt_out_of_projections.bind(this);
    this.shakeFalse = this.shakeFalse.bind(this);
    this.selectDropdown = this.selectDropdown.bind(this);
    this.changeTheValue = this.changeTheValue.bind(this);
    this.changeTheNotificationFlag = this.changeTheNotificationFlag.bind(this);
    this.popupBack = this.popupBack.bind(this);
    this.compareObject = this.compareObject.bind(this);
    this.doneProjectionSettings = this.doneProjectionSettings.bind(this);
    this.backToAccount = this.backToAccount.bind(this);
    this.modifiedTags = this.modifiedTags.bind(this);
    this.modifiedUserTag = this.modifiedUserTag.bind(this);
    this.getEarningsId = this.getEarningsId.bind(this);
    this.optoutDemo = this.optoutDemo.bind(this);
    this.doneClicked = this.doneClicked.bind(this);
    this.doneClickCrunch = this.doneClickCrunch.bind(this);
    this.clearPopupForPutProjectionsError =
      this.clearPopupForPutProjectionsError.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this._analyticActions = this._analyticActions.bind(this);
    this.resetshakeamountvalue = this.resetshakeamountvalue.bind(this);

    this.state = getStateFromStores();
  }

  componentWillMount() {
    ProjectionActionCreator.getEarningsAndCommitment();
    BrowserUtils.setViewPort(1);
  }

  componentDidMount() {
    ProjectionStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    ProjectionActionCreator.resetSettings();
    ProjectionStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    this.setState({
      crunch: false,
    });
    this.setState(getStateFromStores());
    if (ProjectionStore.getProjectionAlertsAmountValue() < 0) {
      this.setState({ dropdownSelection: 2, selectedValue: '2' });
    } else {
      this.setState({ dropdownSelection: 1, selectedValue: '1' });
    }
  }

  // method for click on Opt out in model
  onclickCancelForOptOut() {
    this.setState({
      dLeaveSetup: false,
      cancelFlag: false,
      optOutFlag: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    categoryTags = ProjectionStore.getCategoryTags();
    userTags = ProjectionStore.getUserTags();
    earningIDArray = ProjectionStore.getEarningId();
    let cpProjectionPreferences = {
      enabled: false,
      thresholds: {
        lower: {
          amount: {
            value: parseInt(this.state.alertsAmountValue),
            currency: 'GBP',
          },
        },
      },
      forecasts: [],
      external_notification: this.state.notificationFlag,
      earning_ids: earningIDArray,
      essential_spend: {
        tag_ids: userTags,
        category_ids: categoryTags,
      },
    };
    const requestData = { cpProjectionPreferences, from: 'optout' };
    this._analyticActions(
      '/user/experience/activity',
      'Interacted',
      config.analytics.analytics_action_projections_save_settings,
      'click'
    );
    ProjectionActionCreator.projectionCrunchBackClicked();
    ProjectionActionCreator.doneProjections(
      requestData,
      ProjectionStore.getAccountId()
    );
    // FinancialStoriesActionCreator.handleUpdateFSTileClick();
    // InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
    this.props.backButtonOnDemoSettings();
  }

  // method to handle the leave setup in the projection details page
  onclickLeaveSetup() {
    // this.setState({
    //     dLeaveSetup: false,
    //     cancelFlag: false,
    //     optOutFlag: false,
    //     putProjectionPreferenceErrorHandlingFlag: false,
    //     crunch: false,
    // });
    // ProjectionActionCreator.handleProjectionSettingLeaveSetup();
    // this.props.backToSummary();
    this.props.onclickLeaveSetup();
  }

  // method to handle cancel button in the projection details page
  _cancel_button() {
    this.setState({
      dLeaveSetup: false,
      optOutFlag: false,
      cancelFlag: true,
      putProjectionPreferenceErrorHandlingFlag: false,
      shakeamount: false,
      shakeamountZero: false,
      crunch: false,
    });
  }

  // method for click of opt out of projection
  _opt_out_of_projections() {
    this.setState({
      cancelFlag: false,
      optOutFlag: true,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      shakeamount: false,
      shakeamountZero: false,
      crunch: false,
    });
  }

  // method for animation shake for alert amount in alerts
  shakeFalse() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      shakeamount: false,
      shakeamountZero: false,
      // crunch: false,
    });
  }

  // method for selecting dropdown in alrets
  selectDropdown(e) {
    if (e === '1') {
      this.setState({ selectedValue: '1' });
    } else {
      this.setState({ selectedValue: '2' });
    }
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      onLoad: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    // let alertAmount;
    // let overdraftAmount;
    // let finalalertAmount;
    // if (e === '1') {
    //     this.setState({ shakeamount: false, shakeamountZero: false });
    //     alertAmount = this.state.alertsAmountValue;
    //     if (alertAmount < 0) {
    //         alertAmount = alertAmount * -1.00;
    //     }
    //     this.setState({ alertsAmountValue: alertAmount, dropdownSelection: 1 });
    // } else if (e === '2') {
    //     this.setState({ shakeamountZero: false });
    //     if (this.state.alertsAmountValue === '') {
    //         alertAmount = this.state.alertsAmountValue;
    //         overdraftAmount = this.state.overDraftAmount;
    //     } else {
    //         alertAmount = parseFloat(this.state.alertsAmountValue);
    //         overdraftAmount = parseFloat(this.state.overDraftAmount);
    //     }
    //     if (alertAmount > overdraftAmount) {
    //         this.setState({ shakeamount: true });
    //         this.setState({ dropdownSelection: 1 });
    //     } else {
    //         this.setState({ dropdownSelection: 2 });
    //         this.setState({ shakeamount: false });

    //         if (alertAmount === 0) {
    //             finalalertAmount = 0;
    //         } else if (alertAmount === '') {
    //             finalalertAmount = '';
    //         } else {
    //             finalalertAmount = alertAmount.toFixed(2);
    //         }
    //         this.setState({ alertsAmountValue: finalalertAmount });
    //     }
    // }
    // this.setState({
    //     cancelFlag: false,
    //     optOutFlag: false,
    //     dLeaveSetup: false,
    //     onLoad: false,
    //     putProjectionPreferenceErrorHandlingFlag: false,
    //     crunch: false,
    // });
    let alertAmount;
    let overdraftAmount;
    let finalalertAmount;
    if (e === '1') {
      this.setState({
        shakeamount: false,
        shakeamountZero: false,
        dropdownSelection: 1,
      });
      alertAmount = this.state.alertsAmountValue;
      if (alertAmount < 0) {
        alertAmount = alertAmount * -1.0;
      }
      this.setState({ alertsAmountValue: alertAmount, dropdownSelection: 1 });
    } else if (e === '2') {
      this.setState({ shakeamountZero: false });
      if (this.state.alertsAmountValue === '') {
        alertAmount = this.state.alertsAmountValue;
        overdraftAmount = this.state.overDraftAmount;
      } else {
        alertAmount = parseFloat(this.state.alertsAmountValue);
        overdraftAmount = parseFloat(this.state.overDraftAmount);
      }
      if (alertAmount > overdraftAmount) {
        this.setState({ shakeamount: true });
        this.setState({ dropdownSelection: 1 });
        this.setState({ selectedValue: '1' });
      } else {
        this.setState({ dropdownSelection: 2 });
        this.setState({ shakeamount: false });

        if (alertAmount === 0) {
          finalalertAmount = 0;
        } else if (alertAmount === '') {
          finalalertAmount = '';
        } else {
          finalalertAmount = alertAmount.toFixed(2);
        }
        this.setState({ alertsAmountValue: finalalertAmount });
      }
    }
  }

  // method to change the value in alerts
  changeTheValue(e) {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    this._analyticActions(
      '/user/experience/activity',
      'Interacted',
      config.analytics.analytics_action_projections_threshold_change,
      'click'
    );
    if (this.state.dropdownSelection === 1) {
      const etarget = e.target.value.replace(/[^\d.]*/g, '');
      let strArr;
      let beforeDecimalValue;
      let beforeDecimalLength;
      // check number of dots (max 1)
      const len = etarget.length;
      const index = etarget.indexOf('.');
      const dots = etarget.split('.').length;
      const beforeDecimalLen = etarget.split('.')[0].length;
      let isValid = true;
      // restricted length (max 6) before decimal place.
      beforeDecimalLength = etarget.split('.')[0].length;
      beforeDecimalValue = etarget.split('.')[0];
      strArr = beforeDecimalValue;
      if (
        beforeDecimalLength >= 2 &&
        beforeDecimalLength <= 6 &&
        _.startsWith(beforeDecimalValue, '0') &&
        strArr[1] !== '0'
      ) {
        isValid = true;
        this.setState({ shakeamountZero: false });
      }
      if (
        beforeDecimalLength > 1 &&
        _.startsWith(beforeDecimalValue, '0') &&
        strArr[1] === '0'
      ) {
        this.setState({ shakeamountZero: true });
        e.preventDefault();
        isValid = false;
      } else {
        this.setState({ shakeamountZero: false });
      }
      this.setState({ shakeamount: false });
      if (beforeDecimalLen > 6) {
        isValid = false;
      }
      // decimal point restrict to 1
      if (dots > 2) {
        isValid = false;
      }
      // check only two decimal pointer after dot.
      if (index >= 0) {
        const CharAfterdot = len + 1 - index;
        if (CharAfterdot > 4) {
          isValid = false;
        }
      }
      if (parseFloat(etarget) > 999999) {
        return;
      }
      if (isValid) {
        this.setState(
          {
            alertsAmountValue: etarget,
          },
          () => {}
        );
        ProjectionActionCreator.setAlertNotificationAmount(
          this.state.alertsAmountValue
        );
      }
    } else {
      let strArrr;
      let beforeDecimalValue;
      let beforeDecimalLength;
      let alertAmount;
      let overdraftAmount;
      const etarget = e.target.value.replace(/[^\d.]*/g, '');
      // check number of dots (max 1)
      const len = etarget.length;
      const index = etarget.indexOf('.');
      const dots = etarget.split('.').length;
      const beforeDecimalLen = etarget.split('.')[0].length;
      let isValid = true;
      beforeDecimalLength = etarget.split('.')[0].length;
      beforeDecimalValue = etarget.split('.')[0];
      strArrr = beforeDecimalValue;
      if (
        beforeDecimalLength >= 2 &&
        beforeDecimalLength <= 6 &&
        _.startsWith(beforeDecimalValue, '0') &&
        strArrr[1] !== '0'
      ) {
        isValid = true;
        this.setState({ shakeamountZero: false });
      }
      if (
        beforeDecimalLength > 1 &&
        _.startsWith(beforeDecimalValue, '0') &&
        strArrr[1] === '0'
      ) {
        this.setState({ shakeamountZero: true });
        e.preventDefault();
        isValid = false;
      } else {
        this.setState({ shakeamountZero: false });
      }
      // restricted length (max 6) before decimal place.
      if (beforeDecimalLen > 6) {
        isValid = false;
      }
      // decimal point restrict to 1
      if (dots > 2) {
        isValid = false;
      }
      // check only two decimal pointer after dot.
      if (index >= 0) {
        const CharAfterdot = len + 1 - index;
        if (CharAfterdot > 4) {
          isValid = false;
        }
      }
      alertAmount = parseFloat(this.state.alertsAmountValue);
      overdraftAmount = parseFloat(this.state.overDraftAmount);
      this.setState({ dropdownSelection: 2 });
      if (parseFloat(alertAmount) > 999999) {
        return;
      }
      if (overdraftAmount < e.target.value) {
        this.setState({ shakeamount: true });
        isValid = false;
        e.preventDefault();
        if (e.target.value.length > 6) {
          isValid = false;
        }
      } else if (alertAmount === overdraftAmount && alertAmount !== '') {
        this.setState(
          {
            alertsAmountValue: alertAmount,
          },
          () => {}
        );
        ProjectionActionCreator.setAlertNotificationAmount(
          this.state.alertsAmountValue
        );
      } else if (alertAmount === '') {
        this.setState({ alertAmount: '' });
      } else {
        this.setState({ shakeamount: false });
      }
      if (isValid) {
        this.setState(
          {
            alertsAmountValue: etarget,
          },
          () => {}
        );
        ProjectionActionCreator.setAlertNotificationAmount(
          this.state.alertsAmountValue
        );
      }
    }
  }

  // method to change the notification falg of the alerta and notification flag
  changeTheNotificationFlag() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    this.setState(
      {
        notificationFlag: !this.state.notificationFlag,
      },
      () => {}
    );
    //   ProjectionActionCreator.setAlertsNotificationFlag(this.state.notificationFlag);
  }

  popupBack() {
    FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
  }

  // compare the parameters
  compareObject() {
    categoryTags = ProjectionStore.getCategoryTags();
    userTags = ProjectionStore.getUserTags();
    earningIDArray = ProjectionStore.getEarningId();
    let earningIds = [];
    let catIds = [];
    let userIds = [];
    let earningsF = true;
    let userF = true;
    let catF = true;
    let alertAmountF = true;
    let alertNotFlag = true;
    let alertAmount = parseFloat(ProjectionStore.getActualAmountWithDecimal());
    let alertFlag = this.state.earningsAndCommitmentsData.alerts.map(
      (alerts) => {
        return alerts.notificationFlag;
      }
    );
    this.state.earningsAndCommitmentsData.earnings.map((earningid) => {
      if (earningid.enabled === true) {
        earningIds.push(earningid.id);
      }
    });
    this.state.earningsAndCommitmentsData.essentialSpends.map(
      (essentialTags) => {
        essentialTags.categorytags.map((cbTags) => {
          if (cbTags.enabledFlag) {
            catIds.push(cbTags.id);
          }
        });
      }
    );
    this.state.earningsAndCommitmentsData.essentialSpends.map(
      (essentialTags) => {
        essentialTags.usertags.map((userTags) => {
          if (userTags.enabledFlag) {
            userIds.push(userTags.id);
          }
        });
      }
    );
    earningsF = _.isEqual(earningIds, earningIDArray);
    userF = _.isEqual(userIds, userTags);
    catF = _.isEqual(catIds, categoryTags);
    alertAmountF = _.isEqual(
      alertAmount,
      parseInt(this.state.alertsAmountValue)
    );
    alertNotFlag = _.isEqual(alertFlag[0], this.state.notificationFlag);
    return earningsF && userF && catF && alertAmountF && alertNotFlag;
  }

  // method to handle the projection settings done button
  doneProjectionSettings() {
    const defaultValuecheck = parseFloat(
      ProjectionStore.getProjectionAlertsAmountValue()
    );
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    let alertNegativeValue;
    let newValue;
    if (this.state.dropdownSelection === 2) {
      alertNegativeValue = this.state.alertsAmountValue * -1.0;
      ProjectionStore.setThresholdAmount(alertNegativeValue);
    } else {
      alertNegativeValue = this.state.alertsAmountValue;
      ProjectionStore.setThresholdAmount(alertNegativeValue);
    }
    if (this.props.cancelButtonFlag === false || !this.compareObject()) {
      this._analyticActions(
        '/user/experience/activity',
        'Interacted',
        config.analytics.analytics_action_projections_save_settings,
        'click'
      );
      newValue = ProjectionStore.getThresholdAmount();

      categoryTags = ProjectionStore.getCategoryTags();
      userTags = ProjectionStore.getUserTags();
      earningIDArray = ProjectionStore.getEarningId();
      let amountVal = this.state.alertsAmountValue;
      if (amountVal === '.' || amountVal === '') {
        amountVal = 0;
      }
      let cpProjectionPreferences = {
        enabled: true,
        thresholds: {
          lower: {
            amount: {
              value: parseFloat(newValue),
              currency: 'GBP',
            },
          },
        },
        forecasts: [],
        external_notification: this.state.notificationFlag,
        earning_ids: earningIDArray,

        essential_spend: {
          tag_ids: userTags,
          category_ids: categoryTags,
        },
      };
      const requestData = { cpProjectionPreferences, from: 'done' };
      ProjectionActionCreator.doneProjections(
        requestData,
        ProjectionStore.getAccountId()
      );
    } else if (parseInt(this.state.alertsAmountValue) === defaultValuecheck) {
      this.props.backToSummary();
    }
  }

  // method to handle the back button of the projections settings page in the set up demo mode.
  backToAccount() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: true,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
  }

  modifiedTags(id) {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    categoryTags = ProjectionStore.getCategoryTags();
    const value = _.indexOf(categoryTags, id);
    if (value < 0) {
      categoryTags.push(id);
      this._analyticActions(
        '/user/experience/activity',
        'Interacted',
        config.analytics.analytics_action_projections_add_essential_spend_tags,
        'click'
      );
    } else {
      categoryTags.splice(value, 1);
      this._analyticActions(
        '/user/experience/activity',
        'Interacted',
        config.analytics
          .analytics_action_projections_remove_essential_spend_tags,
        'click'
      );
    }
    ProjectionActionCreator.getCategoryTagsForTab(categoryTags);
  }

  modifiedUserTag(id) {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    userTags = ProjectionStore.getUserTags();
    const value = _.indexOf(userTags, id);
    if (value < 0) {
      userTags.push(id);
      this._analyticActions(
        '/user/experience/activity',
        'Interacted',
        config.analytics
          .analytics_action_projections_remove_essential_spend_tags,
        'click'
      );
    } else {
      userTags.splice(value, 1);
    }
    ProjectionActionCreator.getUserTagsForTab(userTags);
  }

  getEarningsId(id, flag) {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    this._analyticActions(
      '/user/experience/activity',
      'Interacted',
      config.analytics.analytics_action_projections_earnings_transaction_toggle,
      'click'
    );
    earningsId = ProjectionStore.getEarningId();
    const value = _.indexOf(earningsId, id);
    if (value < 0) {
      earningsId.push(id);
    } else {
      earningsId.splice(value, 1);
    }
    ProjectionActionCreator.setEarningsId(earningsId);
  }

  optoutDemo() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      crunch: false,
    });
    // ProjectionActionCreator.projectionCrunchBackClicked();
    // FinancialStoriesActionCreator.handleUpdateFSTileClick();
    // InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
    this.props.backToAccountPage();
  }

  doneClicked() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: true,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
  }

  doneClickCrunch() {
    // ProjectionActionCreator.projectionCrunchBackClicked();
    // FinancialStoriesActionCreator.handleUpdateFSTileClick();
    // InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
    this.props.backToAccountPage();
  }

  clearPopupForPutProjectionsError() {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    ProjectionActionCreator.clearModalFlag(false);
  }

  handleChangeIndex(ind) {
    this.setState({
      cancelFlag: false,
      optOutFlag: false,
      dLeaveSetup: false,
      putProjectionPreferenceErrorHandlingFlag: false,
      crunch: false,
    });
    this.setState({
      index: ind,
    });
  }

  _analyticActions(apath, actionToBe, descriptionOFEvent, eventTriggered) {
    AnalyticsActionCreator.track(
      {
        path: apath,
        action: actionToBe,
      },
      {
        description: descriptionOFEvent,
        event: eventTriggered,
      }
    );
  }

  resetshakeamountvalue() {
    this.setState({
      shakeamount: false,
    });
  }

  render() {
    let am = this.state.alertsAmountValue;
    if (this.state.alertsAmountValue < 0) {
      this.setState({
        alertsAmountValue: am * -1,
      });
    }

    if (BrowserUtils.isMobileView()) {
      return (
        <ProjectionMobileSettings
          crunch={this.state.crunch}
          data={this.state.earningsAndCommitmentsData}
          modifiedUserTag={this.modifiedUserTag}
          modifiedTags={this.modifiedTags}
          projectionSettingsPage={this.state.projectionSettingsPage}
          cancelButtonFlag={this.props.cancelButtonFlag}
          alertsAmountValue={this.state.alertsAmountValue}
          notificationFlag={this.state.notificationFlag}
          changeTheValue={this.changeTheValue}
          _opt_out_of_projections={this._opt_out_of_projections}
          onclickCancelForOptOut={this.onclickCancelForOptOut}
          _cancel_button={this._cancel_button}
          onclickLeaveSetup={this.onclickLeaveSetup}
          optOutFlag={this.state.optOutFlag}
          cancelFlag={this.state.cancelFlag}
          doneProjectionSettings={this.doneProjectionSettings}
          changeTheNotificationFlag={this.changeTheNotificationFlag}
          getEarningsId={this.getEarningsId}
          backToAccount={this.backToAccount}
          content={this.props.content}
          dLeaveSetup={this.state.dLeaveSetup}
          doneClicked={this.doneClicked}
          optoutDemo={this.optoutDemo}
          putProjectionPreferenceErrorHandlingFlag={
            this.putProjectionPreferenceErrorHandlingFlag
          }
          clearPopupForPutProjectionsError={
            this.state.clearPopupForPutProjectionsError
          }
          putProjectionMessage={this.state.putProjectionMessage}
          index={this.state.index}
          handleChangeIndex={this.handleChangeIndex}
          selectDropdown={this.selectDropdown}
          dropdownSelection={this.state.dropdownSelection}
          shakeamount={this.state.shakeamount}
          shakeamountZero={this.state.shakeamountZero}
          dropDownFlag={this.state.dropDownFlag}
          shakeFalse={this.shakeFalse}
          activityIndicator={this.state.activityIndicator}
          popupBack={this.doneClickCrunch}
          selectedValue={this.state.selectedValue}
        />
      );
    } else {
      return (
        <ProjectionSettings
          crunch={this.state.crunch}
          cancelButtonFlag={this.props.cancelButtonFlag}
          alertsAmountValue={this.state.alertsAmountValue}
          notificationFlag={this.state.notificationFlag}
          earningsAndCommitmentsData={this.state.earningsAndCommitmentsData}
          changeTheValue={this.changeTheValue}
          _opt_out_of_projections={this._opt_out_of_projections}
          onclickCancelForOptOut={this.onclickCancelForOptOut}
          _cancel_button={this._cancel_button}
          onclickLeaveSetup={this.onclickLeaveSetup}
          optOutFlag={this.state.optOutFlag}
          cancelFlag={this.state.cancelFlag}
          doneProjectionSettings={this.doneProjectionSettings}
          changeTheNotificationFlag={this.changeTheNotificationFlag}
          getEarningsId={this.getEarningsId}
          modifiedUserTag={this.modifiedUserTag}
          modifiedTags={this.modifiedTags}
          backToAccount={this.backToAccount}
          content={this.props.content}
          dLeaveSetup={this.state.dLeaveSetup}
          doneClicked={this.doneClicked}
          optoutDemo={this.optoutDemo}
          putProjectionPreferenceErrorHandlingFlag={
            this.putProjectionPreferenceErrorHandlingFlag
          }
          clearPopupForPutProjectionsError={
            this.clearPopupForPutProjectionsError
          }
          putProjectionMessage={this.state.putProjectionMessage}
          selectDropdown={this.selectDropdown}
          dropdownSelection={this.state.dropdownSelection}
          shakeamount={this.state.shakeamount}
          shakeamountZero={this.state.shakeamountZero}
          dropDownFlag={this.state.dropDownFlag}
          shakeFalse={this.shakeFalse}
          activityIndicator={this.state.activityIndicator}
          popupBack={this.doneClickCrunch}
          selectedValue={this.state.selectedValue}
          resetshakeamountvalue={this.resetshakeamountvalue}
        />
      );
    }
  }
}

export { SettingsMainPage };
